<template>
    <CompassDialog
        :visible.sync="showModal"
        size="large"
        :title="$t.__('developerPage.WebhooksForms.WebhooksModal.configure_webhook')"
        class="webhooks-modal"
        @closed="closeModal"
    >
        <template #default>
            <div class="dialog__default">
                <preloader :display="loading" />
                <component
                    :is="config.type"
                    v-if="!loading"
                    :id="config.id"
                    :hookType="config.type"
                    :logs="logs"
                ></component>
            </div>
        </template>
    </CompassDialog>
</template>

<script>
import WebhookSlack from 'vcomponents/developerPage/WebhooksForms/Webhooks/WebhookSlack.vue';
import WebhookHttp from 'vcomponents/developerPage/WebhooksForms/Webhooks/WebhookHttp.vue';
import WebhookApi from 'api/webhooks';
import Preloader from 'vcomponents/utilities/Preloader.vue';

export default {
    components: {
        slack: WebhookSlack,
        http: WebhookHttp,
        Preloader,
    },
    props: {
        visible: {
            type: Boolean,
            required: true,
        },
        config: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            showModal: this.visible,
            logs: [],
            loading: false,
        };
    },
    created() {
        this.getLogs();
        EventBus.on('webhook:close', () => {
            this.$emit('close');
        });
    },
    destroyed() {
        EventBus.off('webhook:close');
    },
    methods: {
        closeModal() {
            this.$emit('close');
        },
        /**
         * Get all available logs with events
         */
        async getLogs() {
            this.loading = true;
            await WebhookApi.getEvents().then((response) => {
                this.logs = response.data;
                this.loading = false;
            });
        },

        closeModal() {
            this.showModal = false;
            this.$emit('close');
        },
    },
};
</script>
